import { render, staticRenderFns } from "./ProfileKyc.vue?vue&type=template&id=89f0b2a4"
import script from "./ProfileKyc.vue?vue&type=script&lang=js"
export * from "./ProfileKyc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports